<div mat-dialog-content> 
    <h1 mat-dialog-title fxHide fxShow.gt-xs>{{TitleText}}</h1>
    <h2 mat-dialog-title fxHide.gt-xs>{{TitleText}}</h2>
    <p [innerHtml]="MessageText"></p>
    <form [formGroup]="SearchParamsForm" style="margin-bottom: 20px;">
        <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="20px" fxFlex.xs>
            <mat-form-field>
                <input matInput class="advisorsearch" type="search" id="lastname" formControlName="LastName"
                    placeholder="Last Name" (keyup.enter)="HandleUserKey($event)" />
            </mat-form-field>
            <mat-form-field>
                <input matInput class="advisorsearch" type="search" id="firstname" formControlName="FirstName"
                    placeholder="First Name" (keyup.enter)="HandleUserKey($event)" />
            </mat-form-field>
            <mat-form-field>
                <input matInput class="advisorsearch" type="search" id="sapid" formControlName="SAPID"
                    placeholder="SAPID" (keyup.enter)="HandleUserKey($event)" />
            </mat-form-field>
            <div fxLayout="row" fxLayoutAlign="center center"fxLayoutGap="10px">
                <button mat-raised-button color="primary" (click)="HandleUserSearch($event)">Search</button>
                <button mat-raised-button color="warn" (click)="ClearUserForm($event)">Reset</button>
            </div>
        </div>
    </form>
    <div [hidden]="!(UserSearchConducted)" fxFlex>
        <table mat-table matTableResponsive [dataSource]="dataSource" class="clearSidePaddings" matSort style="width:100%;border:1px solid gray;padding:0 !important">

            <!-- Last Name Column -->
            <ng-container matColumnDef="LastName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
                <td mat-cell *matCellDef="let user"> {{user.LastName}} </td>
            </ng-container>

            <!-- First Name Column -->
            <ng-container matColumnDef="FirstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
                <td mat-cell *matCellDef="let user"> {{user.FirstName}} </td>
            </ng-container>

            <!-- SAPID Column -->
            <ng-container matColumnDef="SAPID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> SAPID </th>
                <td mat-cell *matCellDef="let user" class="centered"> {{user.SAPID}} </td>
            </ng-container>

            <!-- PositionNo Column -->
            <ng-container matColumnDef="PositionNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Position # </th>
                <td mat-cell *matCellDef="let user" class="centered"> {{user.PositionNo}} </td>
            </ng-container>

            <!-- LocalJobTitle Column -->
            <ng-container matColumnDef="LocalJobTitle">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Title </th>
                <td mat-cell *matCellDef="let user" class="centered"> {{user.LocalJobTitle}} </td>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="Email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                <td mat-cell *matCellDef="let user" class="centered"> {{user.Email}} </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="centered"> Actions </th>
                <td mat-cell *matCellDef="let user" class="centered">
                    <button mat-raised-button color="primary" (click)="SelectUser(user)">Select</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="primary" style="border:1px solid gray;line-height:1.5rem"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns; let even = even" [class.even]="even" style="border:1px solid gray;line-height:1.5rem"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                    <em>{{ Searching ? 'Searching...' : 'No search results were found with the provided search criteria.' }}</em>
                </td>
            </tr>
        </table>
        <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20]" aria-label="Select page of searched users"></mat-paginator> -->

    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="CancelHandler()">Cancel</button>
</div>